import React, { useState } from 'react';
import ShopifyBuy from '../Shopify/ShopifyBuy';
import ShopifyMoreOptions from '../Shopify/ShopifyMoreOptions';
import { useNurseryContext } from '../../contexts/NurseryContext';
import { setWaterIcons, setSunIcons } from '../Search/SearchResultsItem';
import { AttributeIcon, PlantSize, Zones } from '../../themes/icons/attributes';
const PdpRelatedItem = ({ data, onAddToShopifyCart, isAvailable, }) => {
    const { nurserySlug } = useNurseryContext();
    const { aka_names: akaNames, dimensions: { H, W }, django_pk: djangoPk, photo, photo_webp: photoWebp, photo_description: photoDescription, plant_type: plantType, primary_name: mainTitle, scientific_name: scientificName, slug, sun_exposure: sunExposure, water_needs: waterNeeds, zones_str: zones, } = data;
    const [openOptions, setOpenOptions] = useState(false);
    let relatedUrl = `/plants/${djangoPk}/${slug}/`;
    if (isAvailable) {
        relatedUrl += `?nurseries=${nurserySlug}`;
    }
    let scientificNameEl = null;
    if (scientificName) {
        scientificNameEl = (React.createElement("p", { className: "plant__name_scientific" },
            "Scientific Name:",
            ' ',
            scientificName));
    }
    const height = H;
    const width = W;
    let plantSize;
    let heightEl;
    let widthEl;
    if (height) {
        heightEl = (React.createElement("p", null,
            React.createElement("span", { className: "key" }, "Height: "),
            React.createElement("span", { className: "value" }, height)));
    }
    if (width) {
        widthEl = (React.createElement("p", null,
            React.createElement("span", { className: "key" }, "Width: "),
            React.createElement("span", { className: "value" }, width)));
    }
    if (height || width) {
        plantSize = (React.createElement("div", { className: "plant__size" },
            React.createElement("h3", null,
                React.createElement(PlantSize, { className: "icn" }),
                "Size"),
            heightEl,
            widthEl));
    }
    let plantPhoto;
    let panelClass = 'panel searchpage__result';
    if (photo !== '') {
        plantPhoto = (React.createElement("a", { href: relatedUrl, title: mainTitle, className: "plant_name_link" },
            React.createElement("div", { className: "plant__photo" },
                React.createElement("picture", null,
                    React.createElement("source", { type: "image/webp", srcSet: photoWebp }),
                    React.createElement("source", { type: "image/jpeg", srcSet: photo }),
                    React.createElement("img", { loading: "lazy", src: photo, alt: photoDescription })),
                React.createElement("div", { className: "plant__photo_hover" },
                    React.createElement("span", null, "View Plant")))));
    }
    else {
        panelClass += ' noPhoto';
        plantPhoto = (React.createElement("a", { href: relatedUrl, title: mainTitle, className: "plant_name_link" },
            React.createElement("div", { className: "plant__photo no_photo" },
                React.createElement("div", { className: "plant__photo_hover" },
                    React.createElement("span", null, "View Plant")))));
    }
    const buyBtn = (React.createElement(ShopifyBuy, { setOpenOptions: setOpenOptions, plant: data, onAddToShopifyCart: onAddToShopifyCart, mainTitle: mainTitle, isAvailable: isAvailable }));
    let waterElem;
    let sunElem = null;
    if ((waterNeeds === null || waterNeeds === void 0 ? void 0 : waterNeeds.length) > 0)
        waterElem = setWaterIcons(waterNeeds);
    if ((sunExposure === null || sunExposure === void 0 ? void 0 : sunExposure.length) > 0)
        sunElem = setSunIcons(sunExposure);
    return (React.createElement("div", { className: panelClass },
        React.createElement("div", { className: "plant__name_cont" },
            React.createElement("h2", { className: "pdp_related__title" },
                React.createElement("a", { href: relatedUrl, title: mainTitle, onBlur: () => { }, onFocus: () => { } }, mainTitle))),
        React.createElement("div", { className: "plant__name_aka" },
            scientificNameEl,
            React.createElement("p", null, akaNames.length > 0 && [
                React.createElement("span", { key: 0 }, "aka "),
                akaNames.join(', '),
            ])),
        React.createElement("div", { className: "plant__detail" },
            React.createElement("div", { className: "plant__info " },
                React.createElement("div", { className: "plant__type" },
                    React.createElement("h3", null,
                        React.createElement(AttributeIcon, { name: "attr1", className: "icn" }),
                        "Plant Type"),
                    React.createElement("p", null, plantType.replace(/\b[a-z]/g, (x) => x.toUpperCase()))),
                React.createElement("div", { className: "plant__zones" },
                    React.createElement("h3", null,
                        React.createElement(Zones, { className: "icn" }),
                        "Zones"),
                    React.createElement("p", null, zones)),
                plantSize),
            React.createElement("div", { className: "plant__info_single" },
                React.createElement("ul", { className: "plant__info_needs" },
                    sunElem,
                    waterElem))),
        plantPhoto,
        buyBtn,
        openOptions && (React.createElement(ShopifyMoreOptions, { openOptions: openOptions, setOpenOptions: setOpenOptions, djangoPk: data.django_pk, variants: data.variants.filter((variant) => variant.available), affiliatedLinks: data.affiliated_links, onAddToShopifyCart: onAddToShopifyCart, partnersData: data.nurseries, plantTitle: mainTitle }))));
};
export default PdpRelatedItem;
